import { useState, useEffect } from 'react';
import StrokeTitle from '../components/ui/StrokeTitle';
import { useInView } from 'react-intersection-observer';
import Button from '../components/ui/Button';
import { Link } from 'react-router-dom';
import ReactPlayer from 'react-player';
import '../styles/pages/top.scss';
import Modal from '../components/ui/Modal';
import FlowerTitle from '../components/ui/FlowerTitle';

const Top = () => {

  const [logo, logoLoaded] = useState(false);
  const [keyart, keyLoaded] = useState(false);

  const [ref2, inView2] = useInView({
    threshold: 1,
    triggerOnce: true
  });


  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      logoLoaded(true);
    };
    img.src = `${process.env.PUBLIC_URL}/img/logo.png`;

    const img2 = new Image();
    img2.onload = () => {
      keyLoaded(true);
    };
    img2.src = `${process.env.PUBLIC_URL}/img/mobile-header.webp`;
  }, []);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    
    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 4
  })

  const [dlcModal, setDLCModal] = useState({
    visible: false,
    current: 0,
    size: 1
  })

    const [endModal, setEndModal] = useState({
    visible: false,
    current: 0,
    size: 4
  })

  return (
    <div className="page-container">
      <Modal modal={modal} setModal={setModal} url="top_ss.jpg"/>
      <Modal modal={dlcModal} setModal={setDLCModal} url="dlc-comp.png"/>
      <Modal modal={endModal} setModal={setEndModal} url="top/additional_content_ss_0.jpg"/>
      <header className="header-wrapper">
        <div className={`screen-left ${logo && keyart && "left-open"}`}/>
        <div className={`screen-right ${logo && keyart && "right-open"}`}/>
        <section className="header-contents">
          <img src={`${process.env.PUBLIC_URL}/img/logo.png`} alt="Disgaea 7 Logo" />
          <div className="video-container"
            style={{
              maxWidth: '400px'
            }}
          >
            <div className="video-wrapper">
              <ReactPlayer url="https://youtu.be/2kU6zhLiQYE"/>
            </div>
          </div>
          {
            windowWidth > 1400 &&
            <img src={`${process.env.PUBLIC_URL}/img/captcha.webp`} alt="Bushido is back, baby" className="captcha" />
          }
          <h1 className='header-date gradient-text'>Buy Now</h1>
        </section>
      </header>
      {
        windowWidth < 1400 &&
        <img src={`${process.env.PUBLIC_URL}/img/captcha.webp`} alt="Bushido is back, baby" className="captcha" />
      }
      <div className="video-container mobile-video"
        style={{
          maxWidth: '90vw'
        }}
      >
      <div className="video-wrapper">
        <ReactPlayer url="https://youtu.be/2kU6zhLiQYE"/>
      </div>
    </div>
      <StrokeTitle text="Disgaea 7 Complete is bigger and better than ever before!"/>
      <div className="pair">
        <div className="accent-wrapper">
          <h3 className="accent-tl black-yellow-text">The Nethertime Support Force<br/> visits Netherworlds of the past!</h3>
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/top/additional_content_ss_01.jpg`} alt="Top-SS" onClick={()=>{
            setEndModal(
              {
                ...endModal,
                'visible': true,
                'current': 1,
              }
            )
          }}/>
        </div>
        <div className="accent-wrapper">
          <h3 className="accent-br black-yellow-text">Asagi joins the fray!</h3>
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/top/additional_content_ss_02.jpg`} alt="Top-SS" onClick={()=>{
            setEndModal(
              {
                ...endModal,
                'visible': true,
                'current': 2,
              }
            )
          }}/>
        </div>
      </div>
      <div className="pair">
        <div className="accent-wrapper">
          <h3 className="accent-tr black-yellow-text">Stats now go up to <br/> 999,999,999!?</h3>
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/top/additional_content_ss_03.jpg`} alt="Top-SS" onClick={()=>{
            setEndModal(
              {
                ...endModal,
                'visible': true,
                'current': 3,
              }
            )
          }}/>
        </div>
        <div className="accent-wrapper">
          <h3 className="accent-bl black-yellow-text">Take on Rakshasa Baal, <br/>the real ultimate evil boss!</h3>
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/top/additional_content_ss_04.jpg`} alt="Top-SS" onClick={()=>{
            setEndModal(
              {
                ...endModal,
                'visible': true,
                'current': 4,
              }
            )
          }}/>
        </div>
      </div>
      <p className={`short-desc white-text ${inView2 && "fadeIn"}`} ref={ref2}>
       Check out everything that's new in Disgaea 7 Complete by clicking that big orange button below!
      </p>
      <Link to="../whats-new#additional_content">
        <Button text="What's New" color="red"/>
      </Link>

      
      <StrokeTitle text="Includes all Disgaea 7 DLC!"/>
      <img 
            style={{maxWidth: '850px', marginBottom: '25px'}}
        className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/dlc-comp.png`} alt="Includes all DLC characters and scenarios previously released for Disgaea 7: Vows of the Virtueless!" 
        onClick={()=>{
            setDLCModal(
            {
                ...dlcModal,
                'visible': true,
                'current': 1,
            }
            )
        }}/>
        <Link to="../whats-new#dlc">
          <Button text="DLC Info" color="red"/>
        </Link>

      <p className={`short-desc white-text ${inView2 && "fadeIn"}`} ref={ref2}>
        Join Fuji and Pirilika as they embark on a perilous journey of redemption, and experience unique features new to the Disgaea series!
      </p>
      <div className="top-ss">
        <img className="ss" src={`${process.env.PUBLIC_URL}/img/ss/top_ss1.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 1,
            }
          )
        }}/>
        <img className="ss" src={`${process.env.PUBLIC_URL}/img/ss/top_ss2.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 2,
            }
          )
        }}/>
        <img className="ss" src={`${process.env.PUBLIC_URL}/img/ss/top_ss3.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 3,
            }
          )
        }}/>
        <img className="ss" src={`${process.env.PUBLIC_URL}/img/ss/top_ss4.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 4,
            }
          )
        }}/>
      </div>
      <FlowerTitle text="Characters"/>
      <div className="top-character-list">
        <div className="top-character-wrapper">
          <Link to='/characters#higan'>
            <Button text="Higan Zesshosai" color="higan"/>
          </Link>
          <img src={`${process.env.PUBLIC_URL}/img/characters/img_main_07.png`} alt="" />
        </div>
        <div className="top-character-wrapper">
          <Link to='/characters#ceefore'>
            <Button text="Ceefore" color="ceefore"/>
          </Link>          
          <img src={`${process.env.PUBLIC_URL}/img/characters/img_main_05.png`} alt="" />
        </div>
        <div className="top-character-wrapper">
          <Link to='/characters#ao'>
            <Button text="Ao" color="ao"/>
          </Link>          
          <img src={`${process.env.PUBLIC_URL}/img/characters/img_main_03.png`} alt="" />
        </div>
        <div className="top-character-wrapper" style={{marginLeft: '25px'}}>
          <Link to='/characters#fuji'>
            <Button text="Fuji" color="fuji"/>
          </Link>          
          <img src={`${process.env.PUBLIC_URL}/img/characters/img_main_01.png`} alt="" />
        </div>
        <div className="top-character-wrapper"  style={{marginRight: '25px'}}>
          <Link to='/characters#pirilika'>
            <Button text="Pirilika" color="pirilika"/>
          </Link>          
          <img src={`${process.env.PUBLIC_URL}/img/characters/img_main_02.png`} alt="" />
        </div>
        <div className="top-character-wrapper">
          <Link to='/characters#suisen'>
            <Button text="Suisen" color="suisen"/>
          </Link>
          <img src={`${process.env.PUBLIC_URL}/img/characters/img_main_06.png`} alt="" />
        </div>
        <div className="top-character-wrapper">
          <Link to='/characters#yeyasu'>
            <Button text="Yeyasu" color="yeyasu"/>
          </Link>
          <img src={`${process.env.PUBLIC_URL}/img/characters/img_main_04.png`} alt="" />
        </div>
      </div>
      <Spec/>
    </div>
  )
}

const Spec = () => (
  <>
    <FlowerTitle text="Specs"/>
    <div className="table-wrapper">
      <table>
       <tbody>
          <tr>
            <th className='yellow-text'>Title:</th>
            <td className='white-text'>Disgaea 7 Complete</td>
          </tr>
          <tr>
            <th className='yellow-text'>Release:</th>
            <td className='white-text'>October 10, 2025</td>
          </tr>
          <tr>
            <th className='yellow-text'>Platform:</th>
            <td className='white-text'> Nintendo Switch™2</td>
          </tr>
          <tr>
            <th className='yellow-text'>Genre:</th>
            <td className='white-text'>Strategy RPG </td>
          </tr>
          <tr>
            <th className='yellow-text'>Player(s):</th>
            <td className='white-text'>1</td>
          </tr>
          <tr>
            <th className='yellow-text'>Text Language:</th>
            <td className='white-text'>English / French</td>
          </tr>
          <tr>
            <th className='yellow-text'>Voice Language:</th>
            <td className='white-text'>English / Japanese</td>
          </tr>
        </tbody>
      </table>
    </div>
  </>
)

export default Top;